/* eslint-disable
    consistent-return,
    no-unused-vars
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import Backbone from 'backbone';
import $ from 'jquery';

import notifications from 'notifications';
import * as popup from 'Popup';
import preferences from 'Preferences';
import * as analytics from 'analytics/Analytics';

const MAX_QUICK_LINKS = 5;

class HomeView extends Backbone.View {
  static initClass() {
    this.prototype.el = '#home';
    this.prototype.events = {
      'click .collapse-toggle': 'toggleCollapse',
      'click .home-recently-accessed .delete-icon': 'deleteSequence',
    };
  }

  deleteSequence(e) {
    return new popup.Confirm({
      title: 'Delete Sequence',
      msg: 'Are you sure you want to delete the sequence? It cannot be recovered.',
    })
      .choice('Cancel', 'btn-af-default')
      .choice('Delete', 'btn-af-danger', () =>
        $.ajax({
          type: 'DELETE',
          url: $(e.currentTarget).data('url'),
        })
          .fail(notifications.notifyError)
          .done(() => {
            $(e.currentTarget).closest('tr').remove();
            return notifications.success('Sequence successfully deleted.');
          })
      )
      .show();
  }

  _hideExtraLinks($nav) {
    return $nav.find('li').each(function (i) {
      if ($(this).hasClass('collapse-toggle') || i < MAX_QUICK_LINKS) {
        return;
      }
      return $(this).addClass('hidden');
    });
  }

  toggleCollapse(e) {
    const $target = $(e.currentTarget);
    const $nav = $target.closest('.nav-stacked');
    if ($target.hasClass('js-hiding')) {
      $target
        .addClass('js-showing')
        .removeClass('js-hiding')
        .find('a')
        .data({originalText: $target.text()})
        .html($('<span>').addClass('glyphicon glyphicon-chevron-up'));
      return $nav.find('li').removeClass('hidden');
    } else {
      $target.addClass('js-hiding').removeClass('js-showing');
      const $a = $target.find('a');
      $a.text($a.data('originalText'));
      return this._hideExtraLinks($nav);
    }
  }

  renderCollapseToggle() {
    const $nav = $(this).closest('.nav-stacked');
    $(this).addClass('js-hiding');
    return this._hideExtraLinks($nav);
  }

  render() {
    const hideExtraLinks = this._hideExtraLinks;
    this.$('.quick-browse .collapse-toggle').each(function () {
      const $nav = $(this).closest('.nav-stacked');
      $(this).addClass('js-hiding');
      return hideExtraLinks($nav);
    });
    this.$('.sort-toggle i').tooltip({
      container: 'body',
      placement: 'bottom',
    });

    const $inviteBtn = this.$('.home-invite-form .btn');
    $inviteBtn.toggleClass('disabled', !$inviteBtn.hasClass('verified'));
    const urlParts = window.location.href.split('?');
    if (urlParts.length > 1 && urlParts[1] === 'invite') {
      this.$('.home-invite-form input').focus();
    }

    return this;
  }
}
HomeView.initClass();

export default HomeView;
